/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { types } from '../actions/sidebar';

const kLocalStorageKey = 'sidebar.collapsed';

function getInitialCollapsed() {
  if (localStorage.getItem(kLocalStorageKey) === 'false') {
    return false;
  }
  return true;
}

const defaultState = {
  collapsed: getInitialCollapsed(),
};

export default (state = defaultState, action) => {
  const { type } = action;
  if (type === types.toggleSidebar) {
    let { collapsed = true } = state;
    collapsed = !collapsed;
    localStorage.setItem(kLocalStorageKey, String(collapsed));
    return {
      ...state,
      collapsed,
    };
  }
  return state;
};




// WEBPACK FOOTER //
// ./src/redux/reducers/sidebar.js